var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col space-y-2"},[_vm._t("headingContainer",function(){return [_c('div',{staticClass:"tracking-wide uppercase",class:{
                'text-lg font-bold  text-primary-700': _vm.prominent,
                'text-xs font-semibold  text-neutral-700': !_vm.prominent,
            }},[_vm._t("heading")],2)]}),_c('div',{staticClass:"flex flex-row space-x-4 text-sm text-neutral-600"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }